import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, FileText, MessageSquare, Upload, Mail } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    jobs: 0,
    blogs: 0,
    testimonials: 0,
    resumes: 0,
    contacts: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const token = localStorage.getItem('adminToken');
    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
      const [jobs, blogs, testimonials, resumes, contacts] = await Promise.all([
        axios.get(`${API}/admin/jobs`, config),
        axios.get(`${API}/admin/blogs`, config),
        axios.get(`${API}/admin/testimonials`, config),
        axios.get(`${API}/admin/resumes`, config),
        axios.get(`${API}/admin/contacts`, config)
      ]);

      setStats({
        jobs: jobs.data.length,
        blogs: blogs.data.length,
        testimonials: testimonials.data.length,
        resumes: resumes.data.length,
        contacts: contacts.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const statCards = [
    { icon: <Briefcase size={32} />, value: stats.jobs, label: 'Jobs', to: '/admin/jobs', color: 'bg-blue-500' },
    { icon: <FileText size={32} />, value: stats.blogs, label: 'Blogs', to: '/admin/blogs', color: 'bg-green-500' },
    { icon: <MessageSquare size={32} />, value: stats.testimonials, label: 'Testimonials', to: '/admin/testimonials', color: 'bg-purple-500' },
    { icon: <Upload size={32} />, value: stats.resumes, label: 'Resumes', to: '/admin/resumes', color: 'bg-orange-500' },
    { icon: <Mail size={32} />, value: stats.contacts, label: 'Contacts', to: '/admin/contacts', color: 'bg-red-500' }
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl font-bold text-primary mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {statCards.map((card, index) => (
          <Link
            key={index}
            to={card.to}
            data-testid={`stat-card-${card.label.toLowerCase()}`}
            className="bg-white p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
          >
            <div className={`inline-flex items-center justify-center w-12 h-12 ${card.color} text-white mb-4`}>
              {card.icon}
            </div>
            <div className="text-3xl font-bold text-primary mb-2">{card.value}</div>
            <div className="text-sm text-muted-foreground uppercase tracking-wider">{card.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-12 bg-white p-6 shadow-md">
        <h2 className="text-2xl font-bold text-primary mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Link
            to="/admin/jobs"
            data-testid="quick-action-add-job"
            className="p-4 border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all text-center font-semibold"
          >
            Add New Job
          </Link>
          <Link
            to="/admin/blogs"
            data-testid="quick-action-add-blog"
            className="p-4 border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all text-center font-semibold"
          >
            Create Blog Post
          </Link>
          <Link
            to="/admin/testimonials"
            data-testid="quick-action-add-testimonial"
            className="p-4 border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all text-center font-semibold"
          >
            Add Testimonial
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
